
import React, { useEffect, useContext, useState } from 'react'
import { SpinnerComponent } from 'react-element-spinner'
import {
	Button,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Col,
	Container,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Table
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import { useNavigate } from 'react-router-dom'
import { library } from "@fortawesome/fontawesome-svg-core"
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

library.add(faTrash)

import VehicleInspectionsService from '../../../../services/VehicleInspectionsService'
import { AuctionsContext } from '../../../../contexts/AuctionsProvider'
import { SessionContext } from '../../../../contexts/SessionProvider'
import SiteService from '../../../../services/SiteService'
import { InspectionsContext } from '../../../../contexts/InspectionsProvider'
import PageTitleContextMenu from '../../../../components/PageTitles/PageTitleContextMenu'
import AuctionsNavBar from '../../../../components/Navbars/AuctionsNavBar'

const AuctionDamages = ({ embedded = false, onRequestClose, onSelectDetailTab }) =>
{
	const { t } = useTranslation()
	const [isBusy, setIsBusy] = React.useState(false)
	const auctionsContext = useContext(AuctionsContext)
	const sessionContext = useContext(SessionContext)
	const inspectionsContext = useContext(InspectionsContext)
	const [selectedPicPath, setSelectedPicPath] = useState('')
	const [vehicleInspectionId, setVehicleInspectionId] = useState('')
	const navigate = useNavigate()

	useEffect(() =>
	{
		initializeComponent()
	}, [])

	const initializeComponent = () =>
	{
		retrieveVehicleInspection()
	}

	const retrieveVehicleInspection = () =>
	{
		setIsBusy(true)
		VehicleInspectionsService
			.getVehicleInspectionDamages(auctionsContext.auction.auctionId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				const addOn = { edited: false, new: false }
				const extendedInspectionDamages = []
				result.data.actionResult.forEach((inspectionDamage) =>
				{
					extendedInspectionDamages.push(Object.assign(inspectionDamage, addOn))
					setVehicleInspectionId(inspectionDamage.parentEntityId)
				})

				inspectionsContext.setVehicleInspectionDamages(extendedInspectionDamages)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}

	const handleSmallInspectionPicClicked = (imagePath) =>
	{
		setSelectedPicPath(imagePath)
	}

	const handleLargeInspectionPicClicked = () =>
	{
		setSelectedPicPath('')
	}

	const handleDamagePropertyChange = (e, vehicleInspectionDamageId) =>
	{
		const { name, value} = e.target
		inspectionsContext.setVehicleInspectionDamages((previousDamages) =>
		{
			let currentDamages = [...previousDamages]
			let damageIndex = currentDamages.findIndex(damage => damage.vehicleInspectionDamageId === vehicleInspectionDamageId)
			currentDamages[damageIndex][name] = value
			currentDamages[damageIndex].edited = true
			return currentDamages
		})
	}

	const handleAddNewDamage = () =>
	{
		inspectionsContext.setVehicleInspectionDamages((previousDamages) =>
		{
			let currentDamages = [...previousDamages]
			currentDamages.push({
				vehicleInspectionDamageId: uuidv4(),
				parentEntityId: vehicleInspectionId,
				parentEntityType: 'VehicleInspection',
				chargeable: true,
				damageArea: '',
				damageAreaFrench: '',
				damageAreaImageCode: '',
				damageRegion: '',
				damageType: '',
				damageTypeFrench: '',
				description: '',
				descriptionFrench: '',
				estGenHrs: 0,
				estimatedRepairCost: 0,
				estMechHrs: 0,
				estMetalHrs: 0,
				estPaintHrs: 0,
				estPdrHrs: 0,
				grade: '',
				gradeWeight: '',
				laborHours: 0,
				partCost: 0,
				partDesc: '',
				partPaintHours: 0,
				damageImages: [],
				new: true
			})
			return currentDamages
		})
	}

	const handleSaveDamages = () =>
	{
		setIsBusy(true)
		VehicleInspectionsService
			.updateVehicleInspectionDamages({ vehicleInspectionId: vehicleInspectionId, vehicleInspectionDamages: inspectionsContext.vehicleInspectionDamages }, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)


			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}

	const handleRemoveDamage = (e, vehicleInspectionDamageId) =>
	{
		e.preventDefault()

		inspectionsContext.setVehicleInspectionDamages((previousDamages) =>
		{
			let currentDamages = [...previousDamages]
			let damageIndex = currentDamages.findIndex(damage => damage.vehicleInspectionDamageId === vehicleInspectionDamageId)
			currentDamages.splice(damageIndex, 1)
			return currentDamages
		})
	}
	
	const handleGoBack = () =>
	{
		if (embedded)
		{
			if (typeof onRequestClose === 'function') onRequestClose()
			return
		}
		navigate('/secure/auctions-listing')
	}

	return (
		<div >
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
			/>
			{
				!embedded &&
				<PageTitleContextMenu
					heading={ t('Auctions.Damages.Title') }
					subheading={ auctionsContext.auction.auctionVehicle.vehicle.year + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.make + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.model + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.trim + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.serialNumber
					}
					icon="pe-7s-ticket icon-gradient bg-premium-dark"
					headerOptions={ { showBack: true, backCommand: () => { handleGoBack() }, showReload: false, reloadCommand: null } }
				/>
			}
			<Container className={ embedded ? "" : "mt--6" } fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader style={{padding: '0.5rem 0.75rem'}}>
								<AuctionsNavBar
									parentComponent={'auction-damages'}
									onSelect={ embedded ? onSelectDetailTab : undefined }
								/>
							</CardHeader>
							<CardBody>
								<Row>
									<Col md="12">
										<div className="text-right">
											<Button
												color="secondary"
												size="sm"
												onClick={ () => handleAddNewDamage() }
											>
												Add New Damage
											</Button>
										</div>
									</Col>
								</Row>
								<Row>
									<Col md="12">
										<div className="table-responsive" >
											<Table className="align-items-center table-flush">
												<thead className="thead-light">
													<tr>
														<th className="sort" scope="col">{ t('Auctions.Damages.DamageArea') }</th>
														<th className="sort" scope="col">{ t('Auctions.Damages.DamageType') }</th>
														<th className="sort" scope="col">{ t('Auctions.Damages.EstimatedRepair') }</th>
														<th className="sort" scope="col">{ t('Auctions.Damages.Pictures') }</th>
													</tr>
												</thead>
												<tbody className="list">
													{inspectionsContext.vehicleInspectionDamages.map((damage) => (
														<tr key={ damage.vehicleInspectionDamageId } style={{ cursor: 'pointer' }} >
															<td>
																<Input
																	name="damageArea"
																	type="text"
																	className="form-control-sm"
																	value={ damage.damageArea }
																	onChange={ (ev) => { handleDamagePropertyChange(ev, damage.vehicleInspectionDamageId) } }
																/>
															</td>
															<td>
																<Input
																	name="damageType"
																	type="text"
																	className="form-control-sm"
																	value={ damage.damageType }
																	onChange={ (ev) => { handleDamagePropertyChange(ev, damage.vehicleInspectionDamageId) } }
																/>
															</td>
															<td>
																<Input
																	name="estimatedRepairCost"
																	type="text"
																	className="form-control-sm"
																	value={ damage.estimatedRepairCost }
																	onChange={ (ev) => { handleDamagePropertyChange(ev, damage.vehicleInspectionDamageId) } }
																/>
															</td>
															<td>
																<div style={{ display: 'inline-block' }}>
																	{damage.damageImages.map((damageImage) => (
																		<div key={ damageImage.vehicleInspectionPictureId } className="inspection-pic" style={{ display:'inline', paddingLeft: '10px' }}>
																			<img
																				className="inspection-pic-sm"
																				src={ damageImage.imagePath }
																				width="100px"
																				height="100px" alt="..."
																				onClick={ () => { handleSmallInspectionPicClicked(damageImage.imagePath) } }
																				style={{ cursor: 'pointer' }}
																			/>
																		</div>
																	))}
																</div>
															</td>
															<td>
																<Button
																	className="btn-icon-only rounded-circle"
																	color="light"
																	title="Create Auction"
																	onClick={ (event) => handleRemoveDamage(event, damage.vehicleInspectionDamageId) }
																>
																	<span className="btn-inner--icon">
																		<FontAwesomeIcon icon={ faTrash } style={{ color: 'red' }} />
																	</span>
																</Button>
															</td>
														</tr>
													))}
												</tbody>
											</Table>
										</div>
									</Col>
								</Row>
								<Row>
									<Col md="12">
										<Button
											block
											color="primary"
											className="btn-block"
											onClick={ handleSaveDamages }
											style={{'marginTop': '20px'}}
										>
											Save Damages
										</Button>
									</Col>
								</Row>
							</CardBody>
							<CardFooter></CardFooter>
						</Card>
					</div>
				</Row>

				<Modal
					size="lg"
					isOpen={ selectedPicPath.length > 0 }
					toggle={ () => handleLargeInspectionPicClicked() }
				>
					<ModalHeader toggle={ () => handleLargeInspectionPicClicked() } charCode="Y"></ModalHeader>
					<ModalBody>
						<Card className="border-0 mb-0">
							<CardBody>
								<div className="text-center">
									<img className="inspection-pic-lg" src={selectedPicPath} width="700px" height="600px" alt="..."/>
								</div>
								<div className="text-center">
									<Button
										className="my-4"
										color="primary"
										type="button"
										onClick={() => handleLargeInspectionPicClicked()}
									>
										Close
									</Button>
								</div>
							</CardBody>
						</Card>
					</ModalBody>
					<ModalFooter></ModalFooter>
				</Modal>

			</Container>

		</div>
	)
}

export default AuctionDamages
